// Dil seçici — Header-də. en / az / ru / tr arası keçid.

import React, { useEffect, useRef, useState } from "react";
import { Globe, Check } from "lucide-react";

import { useTheme } from "../context/ThemeContext";
import { useI18n, LANGUAGES, type Lang } from "../i18n/I18nContext";

const LanguageSwitcher: React.FC = () => {
  const { isDark } = useTheme();
  const { lang, setLang, t } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) ?? LANGUAGES[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        title={t("lang.title")}
        aria-label={t("lang.title")}
        className={`flex items-center gap-1.5 p-2.5 rounded-xl transition-all active:scale-95 ${
          isDark
            ? "bg-[#22252f] text-gray-300 hover:bg-[#2a2e3a]"
            : "bg-gray-50 text-gray-600 hover:bg-gray-100"
        }`}
      >
        <Globe className="w-5 h-5" />
        <span className="text-xs font-semibold">{current.short}</span>
      </button>

      {open && (
        <div
          className={`absolute right-0 mt-2 w-44 rounded-xl border shadow-lg z-50 overflow-hidden ${
            isDark ? "bg-[#1a1d27] border-[#2a2e3a]" : "bg-white border-gray-100"
          }`}
        >
          {LANGUAGES.map((l) => {
            const active = l.code === lang;
            return (
              <button
                key={l.code}
                onClick={() => {
                  setLang(l.code as Lang);
                  setOpen(false);
                }}
                className={`w-full flex items-center justify-between px-3 py-2.5 text-sm transition ${
                  isDark
                    ? "hover:bg-[#22252f] text-gray-200"
                    : "hover:bg-gray-50 text-gray-700"
                } ${active ? "font-semibold" : ""}`}
              >
                <span className="flex items-center gap-2">
                  <span
                    className={`text-[11px] font-bold w-7 text-center rounded ${
                      isDark ? "bg-[#2a2e3a] text-gray-300" : "bg-gray-100 text-gray-500"
                    }`}
                  >
                    {l.short}
                  </span>
                  {l.label}
                </span>
                {active && <Check className="w-4 h-4 text-[var(--primary)]" />}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
